import React, { Fragment, useState, useEffect } from 'react'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox'
import {
  Checkbox,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material'

import { ApiConfig } from '../../../config/api'
import { useApi } from '../../../hooks/useApi'
import axios from 'axios'
import { WorkOrderOutbound } from '../../../interfaces/WorkOrderOutbound'
import { Loading } from '../../../components/UI'
import { Status } from '../../../hooks/useFetchState'

interface RemoveOrderFromWorkOrderProps {
  workOrderId: number
  ordersToRemove: number[]
  setSelectedOrdersToRemove: (selectedOrders: number[]) => void
  loading: boolean
}

const getWorkOrderById = (workOrderId: number) => {
  const url = new URL(`${ApiConfig.WorkOrderOutboundApi}/${workOrderId}`)

  return axios.get(url.toString())
}

export const RemoveOrderFromWorkOrder: React.FC<RemoveOrderFromWorkOrderProps> =
  ({ workOrderId, ordersToRemove, setSelectedOrdersToRemove, loading }) => {
    const { state, callApi } = useApi<WorkOrderOutbound>()

    const requestWorkOrderOutbound = () => {
      callApi(getWorkOrderById(workOrderId))
    }

    const [orderToSearch, setOrderToSearch] = useState<string>('')

    useEffect(() => {
      requestWorkOrderOutbound()
    }, [])

    const handleChecked = (id: number, e: any) => {
      const {
        target: { checked }
      } = e

      if (checked) {
        setSelectedOrdersToRemove([...ordersToRemove, id])
      } else {
        const elementsWithoutChecked = ordersToRemove.filter(
          (existingOrderId) => existingOrderId !== id
        )
        setSelectedOrdersToRemove(elementsWithoutChecked)
      }
    }

    const handleSelectAll = () => {
      const allOrderIdsFromWorkOrder: number[] =
        state.data?.orderDetails.map((item) => item.id) || []

      setSelectedOrdersToRemove(allOrderIdsFromWorkOrder)
    }

    const handleDeselectAll = () => {
      setSelectedOrdersToRemove([])
    }

    const isSubmitting = loading || state.status === Status.Loading

    if (isSubmitting) {
      return <Loading />
    }

    const checkboxElements = state.data?.orderDetails
      .filter((item) =>
        orderToSearch !== ''
          ? item.referenceId.toString().startsWith(orderToSearch)
          : true
      )
      .map((order) => (
        <Grid
          container
          item
          xs={12}
          sm={6}
          lg={4}
          alignItems='center'
          justify='flex-start'
        >
          <Checkbox
            onChange={(e) => handleChecked(order.id, e)}
            name={`checkbox${order.id}`}
            id={`checkbox${order.id}`}
            color='primary'
            checked={
              ordersToRemove.filter((orderId) => orderId === order.id).length >
              0
            }
          />
          <Typography variant='body2'>{order.referenceId}</Typography>
        </Grid>
      ))

    return (
      <Fragment>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} sm={3}>
            <Typography variant="body1">Buscar Por:</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id='standard-basic'
              label='Nro Pedido'
              onChange={(e) => setOrderToSearch(e.target.value.toUpperCase())}
              disabled={isSubmitting}
              variant='outlined'
              value={orderToSearch.toUpperCase()}
              
            />
          </Grid>
          <Grid container item xs={12} sm={3} justify='flex-end'>
            {ordersToRemove.length === 0 && (
              <IconButton color='primary' onClick={handleSelectAll}>
                <CheckBoxOutlineBlankIcon />
              </IconButton>
            )}
            {state.data?.orderDetails !== undefined &&
              ordersToRemove.length === state.data?.orderDetails.length && (
                <IconButton color='primary' onClick={handleDeselectAll}>
                  <CheckBoxIcon />
                </IconButton>
              )}
            {ordersToRemove.length > 0 &&
              ordersToRemove.length !== state.data?.orderDetails.length && (
                <IconButton color='primary' onClick={handleDeselectAll}>
                  <IndeterminateCheckBoxIcon />
                </IconButton>
              )}
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          {checkboxElements}
        </Grid>
      </Fragment>
    )
  }
